import { Component, ElementRef, inject, OnInit } from '@angular/core';

import { _BarClassicWidgetsEngine } from './bar-classic-widgets-engine.provider';
import { _BarBurgerprofielEngine } from './burgerprofiel/bar-burgerprofiel-engine-provider';

@Component({
    selector: 'baas-global-header',
    standalone: true,
    template: ''
})
export class BaasGlobalHeader implements OnInit {
    readonly #elRef = inject(ElementRef);
    readonly #burgerprofielEngine = inject(_BarBurgerprofielEngine);
    readonly #classicWidgetsEngine = inject(_BarClassicWidgetsEngine);

    ngOnInit(): void {
        // burgerprofiel header
        if (this.#burgerprofielEngine.visible) this.#burgerprofielEngine.tryMountHeader(this.#elRef.nativeElement);
        // classic header
        else this.#classicWidgetsEngine.tryMountHeader(this.#elRef.nativeElement);
    }
}
